export default __webpack_public_path__ + "static/media/howto1.73358014.png";